import React, { useState } from 'react';
import Modal from 'react-modal';
import { useNavigate } from "react-router-dom";
import './CreateExternalModal.css';

const CreateExternalUserModal = ({ isOpen, onRequestClose, onExternalUserCreated }) => {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [contactNumber, setContactNumber] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		const newExternalUser = { firstName, lastName, email, contactNumber, password };

		try {
			const response = await fetch('https://api.hgcdental.clinic/api/register', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(newExternalUser),
			});

			const data = await response.json();

			if (!response.ok) {
				setError(data.message || 'Failed to create external user');
			} else {
				// Store user credentials for verification
				localStorage.setItem("email", email);
				localStorage.setItem("password", password);

				console.log("Registration successful. Redirecting to /verify-email...");

				console.log("Registration successful, attempting navigation...");
				navigate("/verify-email");
				console.log("Navigation function executed.");

			}
		} catch (error) {
			console.error('Error:', error);
			setError('An error occurred while creating the external user.');
		} finally {
			setLoading(false);
		}
	};


	const resetForm = () => {
		setFirstName('');
		setLastName('');
		setEmail('');
		setContactNumber('');
		setPassword('');
	};

	return (
		<Modal isOpen={isOpen} onRequestClose={onRequestClose} className="modal" overlayClassName="overlay">
			<button className="close-icon" onClick={onRequestClose}>&times;</button>
			<h2>Create External User</h2>
			<div className="modal-divider-3" />
			{error && <div className="error-message">{error}</div>}
			<form onSubmit={handleSubmit}>
				<div>
					<label>First Name:</label>
					<input
						type="text"
						value={firstName}
						onChange={(e) => setFirstName(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Last Name:</label>
					<input
						type="text"
						value={lastName}
						onChange={(e) => setLastName(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Email:</label>
					<input
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Contact Number:</label>
					<input
						type="text"
						value={contactNumber}
						onChange={(e) => setContactNumber(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Password:</label>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
				</div>
				<div className="modal-divider-3" />
				<button type="submit" disabled={loading}>
					{loading ? 'Creating...' : 'Create External User'}
				</button>
			</form>
		</Modal>
	);
};

export default CreateExternalUserModal;